import groq from 'groq';

import { ASSET, CLOUDINARY_VIDEO } from '../common';

export const MEDIA = groq`
  desktopMedia[0]{
    _type,
    _type == 'altImage' => {
      ${ASSET}
    },
    _type == 'video' => {
      title,
      controls,
      url
    },
    _type == 'gif' => {
      ${CLOUDINARY_VIDEO}
    },
    _type == 'storyVideo' => {
      ${CLOUDINARY_VIDEO},
    }
  },
  mobileMedia[0]{
    _type,
    _type == 'altImage' => {
      ${ASSET}
    },
    _type == 'video' => {
      title,
      controls,
      url
    },
    _type == 'gif' => {
      ${CLOUDINARY_VIDEO}
    },
    _type == 'storyVideo' => {
      ${CLOUDINARY_VIDEO},
    }
  },
`;

export const MEDIA_BLOCK = groq`
  _type == 'timeline_mediaBlock' => {
    ${MEDIA}
  }
`;
